import { render } from "./NewsRoomHeader.vue?vue&type=template&id=4b6d5e70"
import script from "./NewsRoomHeader.vue?vue&type=script&lang=js"
export * from "./NewsRoomHeader.vue?vue&type=script&lang=js"

import "./NewsRoomHeader.vue?vue&type=style&index=0&id=4b6d5e70&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__